(function () {
  'use strict';

  var routes = (window.PBC && window.PBC.routes) || {};
  var FREE_SHIP_THRESHOLD = (window.PBC && window.PBC.freeShipThreshold) || 0; // in cents, 0 = disabled

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-pbc-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent : '';
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) btn.textContent = '✓ Added';
        refreshCart(true);
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1500);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  });

  /* ---------- Cart drawer ---------- */
  window.openCartDrawer = function () {
    refreshCart(false);
    document.getElementById('cartDrawer').classList.add('open');
    document.getElementById('cartOverlay').classList.add('open');
  };
  window.closeCartDrawer = function () {
    document.getElementById('cartDrawer').classList.remove('open');
    document.getElementById('cartOverlay').classList.remove('open');
  };

  function updateFreeShip(total) {
    var bar = document.getElementById('freeshipBar');
    if (!bar || FREE_SHIP_THRESHOLD <= 0) { if (bar) bar.style.display = 'none'; return; }
    bar.style.display = 'block';
    var text = document.getElementById('freeshipText');
    var fill = document.getElementById('freeshipFill');
    var pct = Math.min(100, (total / FREE_SHIP_THRESHOLD) * 100);
    fill.style.width = pct + '%';
    if (total >= FREE_SHIP_THRESHOLD) {
      text.innerHTML = '🎉 <strong>You’ve unlocked free shipping!</strong>';
    } else {
      text.innerHTML = 'You’re <strong>' + money(FREE_SHIP_THRESHOLD - total) + '</strong> away from free shipping';
    }
  }

  function refreshCart(openAfter) {
    fetch(routes.cart).then(function (r) { return r.json(); }).then(function (cart) {
      var count = document.getElementById('cartCount');
      if (count) count.textContent = cart.item_count;
      var subtotal = document.getElementById('cartSubtotal');
      if (subtotal) subtotal.textContent = money(cart.total_price);
      updateFreeShip(cart.total_price);
      var items = document.getElementById('cartDrawerItems');
      if (items) {
        if (cart.items.length === 0) {
          items.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
        } else {
          items.innerHTML = cart.items.map(function (item) {
            return '<div class="cart-drawer-line" data-key="' + item.key + '">' +
              '<img src="' + (item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '') + '" alt="">' +
              '<div class="cart-drawer-line-info">' +
                '<div class="cart-drawer-line-title">' + item.product_title + '</div>' +
                '<div class="cart-drawer-line-meta">' + item.quantity + ' × ' + money(item.price) + '</div>' +
              '</div>' +
              '<button class="cart-drawer-line-remove" data-remove="' + item.key + '" aria-label="Remove">✕</button>' +
            '</div>';
          }).join('');
        }
      }
      if (openAfter) window.openCartDrawer();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove]');
    if (!btn) return;
    fetch(routes.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-remove'), quantity: 0 })
    }).then(function () { refreshCart(false); });
  });

  /* ---------- Homepage filter tabs ---------- */
window.pbcFilter = function (btn, tag) {
    document.querySelectorAll('#filterTabs .filter-tab').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('#productGrid .product-card-wrap').forEach(function (card) {
      var tags = (' ' + (card.getAttribute('data-tags') || '').trim() + ' ');
      var match = tag === 'all' || tags.indexOf(' ' + tag + ' ') !== -1;
      card.style.display = match ? '' : 'none';
    });
  };

  /* ---------- Sticky add-to-cart (product page) ---------- */
  var stickyBar = document.getElementById('stickyAtc');
  var buyRow = document.getElementById('productBuyRow');
  if (stickyBar && buyRow) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { stickyBar.classList.toggle('show', !e.isIntersecting); });
    }, { threshold: 0 });
    io.observe(buyRow);
    var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var mainForm = document.getElementById('productForm');
      if (mainForm) mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.querySelector('button[type="submit"]').click();
    });
  }

  /* ---------- Predictive search ---------- */
  var searchInput = document.getElementById('searchInput');
  if (searchInput) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = this.value.trim();
      var results = document.getElementById('searchResults');
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources.results.products) || [];
            if (!products.length) { results.innerHTML = '<div class="search-no-results">No results for "' + q + '"</div>'; return; }
            results.innerHTML = products.map(function (p) {
              return '<a href="' + p.url + '" class="search-result-item">' +
                (p.image ? '<img src="' + p.image + '" alt="">' : '') +
                '<span>' + p.title + '</span>' +
                '<span class="search-result-price">' + p.price + '</span></a>';
            }).join('');
          });
      }, 250);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var so = document.getElementById('searchOverlay');
      if (so) so.classList.remove('open');
      window.closeCartDrawer();
    }
  });
})();
